<template>
  <div class="wrapper">
    <!--分页-->
    <div class="searchBar">
      <h2>
        论文记录
        <el-button
          type="primary"
          icon="el-icon-upload2"
          class="saveBar"
          @click="goTo('thesisUpload')"
        >
          上传论文
        </el-button>
      </h2>
    </div>
    <div class="tableContainer">
      <Table :columns="columns" :data="thesisList" border>
        <template slot-scope="{ row, index }" slot="action">
          <div>
            <el-button
              plain
              class="bluBar"
              @click="goToDetail('thesisAudit', row, 2)"
              >详情
            </el-button>
            <el-button
              v-show="(row.reviewStatusCode = 1)"
              class="bluBar"
              @click=""
            >
              预约面试
            </el-button>
            <el-button v-show="(row.reviewStatusCode = 0)" class="bluBar">
              再次提交
            </el-button>
          </div>
        </template>
      </Table>
      <el-row>
        <el-col :span="24">
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="paginations.page_index"
              :page-sizes="paginations.page_sizes"
              :page-size.sync="paginations.page_size"
              :layout="paginations.layout"
              :total="paginations.total"
            >
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>

    <br />

    <h2>答辩记录</h2>

    <div class="tableContainer1">
      <Table :columns="interviewColumns" :data="myInterviewList" border>
        <template slot-scope="{ row, index }" slot="action">
          <div>
            <el-button
              plain
              class="bluBar"
              @click="goToDetail('paperInterviewDetail', row)"
              >详情
            </el-button>
          </div>
        </template>
      </Table>
      <el-row>
        <el-col :span="24">
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page.sync="paginations1.page_index"
              :page-sizes="paginations1.page_sizes"
              :page-size.sync="paginations1.page_size"
              :layout="paginations1.layout"
              :total="paginations1.total"
            >
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getMyPaperList, getMyInterviewPage } from "@/api/paper.js";

export default {
  data() {
    return {
      paginations: {
        page_index: 1, //当前页
        page_size: 30, //每页多少条
        total: 30,
        page_sizes: [10, 15, 30, 50],
        layout: "total,sizes, prev, pager, next,jumper",
      },

      paginations1: {
        page_index: 1, //当前页
        page_size: 30, //每页多少条
        total: 30,
        page_sizes: [10, 15, 30, 50],
        layout: "total,sizes, prev, pager, next,jumper",
      },
      searchCondition: {
        pageSize: 30,
        jumpPage: 1,
        userId: 50,
      },
      columns: [
        // {
        //   type: "selection",
        //   width: 60,
        //   align: "center",
        //   key: "choose",
        // },
        {
          title: "序号",
          type: "index",
          width: 70,
        },
        {
          title: "论文名称",
          key: "paperName",
        },
        {
          title: "审核状态",
          key: "reviewStatus",
        },

        {
          title: "提交时间",
          key: "createTime",
        },
        {
          title: "预约时间",
          key: "reserveTime",
        },
        {
          title: "审核意见",
          key: "reviewDec",
        },
        {
          title: "操作",
          slot: "action",
          key: "createTime",
        },
      ],
      thesisList: [],
      myInterviewList: [],
      interviewColumns: [
        // {
        //   type: "selection",
        //   width: 60,
        //   align: "center",
        //   key: "choose",
        // },
        {
          title: "序号",
          type: "index",
          width: 70,
        },
        {
          title: "论文名称",
          key: "paperName",
        },
        {
          title: "成绩",
          key: "score",
        },

        {
          title: "答辩时间",
          key: "interviewTime",
        },
        {
          title: "状态",
          key: "interviewStatus",
        },
        {
          title: "操作",
          slot: "action",
          key: "createTime",
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.getMyPaperList();
    this.getMyInterviewPage();
  },
  methods: {
    handleSizeChange(page_size) {
      console.log(`每页 ${page_size} 条`);
      this.paginations.page_size = page_size;
      this.searchCondition.pageSize = page_size;
      this.getMyPaperList();
    },
    handleCurrentChange(page) {
      console.log(`当前页: ${page}`);
      this.paginations.page_index = page;
      this.searchCondition.jumpPage = page;
      this.getMyPaperList();
    },
    handleSizeChange1(page_size) {
      console.log(`每页 ${page_size} 条`);
      this.paginations.page_size = page_size;
      this.searchCondition.pageSize = page_size;
      this.getMyPaperList();
    },
    handleCurrentChange1(page) {
      console.log(`当前页: ${page}`);
      this.paginations.page_index = page;
      this.searchCondition.jumpPage = page;
      this.getMyPaperList();
    },

    getMyPaperList() {
      console.log("筛选条件searchCondition=", this.searchCondition);
      getMyPaperList(this.searchCondition).then((data) => {
        console.log("paperScoreSettingList结果", data);
        this.thesisList = data.records;
        this.paginations.total = data.total;
      });
    },
    getMyInterviewPage() {
      console.log("筛选条件searchCondition=", this.searchCondition);
      getMyPaperList(this.searchCondition).then((data) => {
        console.log("paperScoreSettingList结果", data);
        this.myInterviewList = data.records;
        this.paginations1.total = data.total;
      });
    },
    goToDetail(routerName, item, e) {
      this.$router.push({ name: routerName, query: { id: item.id, type: e } });
    },
    goTo(url) {
      this.$router.push({ name: url });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  background: #fff;
  padding: 20px;
  .searchBar {
    .saveBar {
      float: right;
    }
  }

  .tableContainer {
    background: #fff;
    padding: 20px;

    .bluBar {
      width: auto;
      color: #36aafd;
      border: 1px solid #36aafd;
      padding: 7px 10px;
      border-radius: 4px !important;
    }
  }

  .tableContainer1 {
    background: #fff;
    padding: 20px;

    .bluBar {
      width: auto;
      color: #36aafd;
      border: 1px solid #36aafd;
      padding: 7px 10px;
      border-radius: 4px !important;
    }
  }
}
</style>
